import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "#fff",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M16 18.83A3 3 0 0 0 18 16V9H6v7c0 1.306.835 2.418 2 2.83V21a1 1 0 1 0 2 0v-2h4v2a1 1 0 1 0 2 0zM16 11H8v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", { d: "M7 12a1 1 0 0 0-1-1H2a1 1 0 1 0 0 2h4a1 1 0 0 0 1-1m10 0a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-4a1 1 0 0 0-1 1" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M7.553 2.106a1 1 0 0 1 1.341.447l.517 1.033A6 6 0 0 1 12 3c.927 0 1.805.21 2.59.586l.516-1.033a1 1 0 0 1 1.789.894l-.654 1.308A5.98 5.98 0 0 1 18 9v2H6V9c0-1.658.672-3.159 1.76-4.245l-.654-1.308a1 1 0 0 1 .447-1.341m6.822 3.675.048.036A4 4 0 0 1 16 9H8a4 4 0 0 1 1.625-3.219A4 4 0 0 1 12 5c.89 0 1.71.29 2.375.781",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }